import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useStepNavigate } from "./hooks/useStepNavigate";
import { useEffect, useRef } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { StaticOptionsProvider } from "./context/StaticOptionsContext";
import { AuthProvider } from "./context/AuthContext";
import { OrderSaveProvider } from "./context/OrderSaveContext";
import { PrescriptionSaveProvider } from "./context/PrescriptionSaveContext.js";
import { InvoiceSaveProvider } from "./context/InvoiceSaveContext";
import { OrderProvider, useOrder } from "./context/OrderContext";
import { useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/routes/ProtectedRoute";
import AdminProtectedRoute from "./components/routes/AdminProtectedRoute";
import PublicRoute from "./components/routes/PublicRoute";

import RendelesTipus from "./Pages/RendelesTipus";
import VoltMegrendeles from "./Pages/VoltMegrendeles";
import Taj from "./Pages/Taj";
import AdatVenyes from "./Pages/AdatVenyes";
import Rendelesek from "./Pages/Rendelesek";
import Login from "./Pages/Login";
import Home from "./Pages/Home";
import Meretlap from "./Pages/Meretlap";
import Adat from "./Pages/Adat";
import VenyesTipus from "./Pages/VenyesTipus";
import KozgyogyKerdes from "./Pages/KozgyogyKerdes";
import UzemiKerdes from "./Pages/UzemiKerdes";
import EgyediKerdes from "./Pages/EgyediKerdes";
import Mennyiseg from "./Pages/Mennyiseg";
import CipoTipus from "./Pages/CipoTipus";
import CipoForma from "./Pages/CipoForma";
import ModellValaszto from "./Pages/ModellValaszto";
import ValasztottModell from "./Pages/ValasztottModell";
import RogzitesTipus from "./Pages/RogzitesTipus";
import SpecialisIgeny from "./Pages/SpecialisIgeny";
import EgySzinu from "./Pages/EgySzinu";
import VenyesTartozek from "./Pages/VenyesTartozek";
import TartozekValaszto from "./Pages/TartozekValaszto";
import BetetTartozek from "./Pages/BetetTartozek";
import TeritesiDij from "./Pages/TeritesiDij";
import TobbSzinu from "./Pages/TobbSzinu";
import Kerdesek from "./Pages/Kerdesek";
import TalpSarok from "./Pages/TalpSarok";
import TalpRamaSzine from "./Pages/TalpRamaSzine";
import MeretfelveteliHely from "./Pages/MeretfelveteliHely";
import OrrForma from "./Pages/OrrForma";
import OsszesitoTablazat from "./Pages/OsszesitoTablazat";
import PartnerValaszto from "./Pages/PartnerValaszto";
import BelesTipus from "./Pages/BelesTipus";
import KeregTipus from "./Pages/KeregTipus";
import OrrMerevito from "./Pages/OrrMerevito";
import Donga from "./Pages/Donga";
import Gordulo from "./Pages/Gordulo";
import CsatolandoMedia from "./Pages/CsatolandoMedia";
import Meretvetel from "./Pages/Meretvetel";
import MeretvetelSzaras from "./Pages/MeretvetelSzaras";
import Emeles from "./Pages/Emeles";
import FelolvasoTabla from "./Pages/FelolvasoTabla";
import VenyekLista from "./Pages/VenyekLista";
import BetetTipus from "./Pages/BetetTipus.js";
import Alairas from "./Pages/Alairas.js";
import MeretlapNyomtatas from "./Pages/MeretlapNyomtatas.js";
import ProjektValaszto from "./Pages/ProjektValaszto.js";
import RendelesAdatlap from "./Pages/RendelesAdatlap.js";
import TuzesSzine from "./Pages/TuzesSzine.js";
import Diviziok from "./Pages/Diviziok.js";
import Admin from "./Pages/Admin.js";
import AdminModell from "./Pages/AdminModell.js";
import AdminModellKezelo from "./Pages/AdminModellKezelo.js";
import RendelesKezelo from "./Pages/RendelesKezelo.js";
import ElolegSzamla from "./Pages/ElolegSzamla.js";
import Szamlazas from "./Pages/Szamlazas.js";
import Talp from "./Pages/Talp.js";
import Rama from "./Pages/Rama.js";
import Koztalp from "./Pages/Koztalp.js";

// import KapocsFuzo from "./Pages/KapocsFuzo.js";

function ConditionalStaticOptions({ children }) {
	const { isAuthenticated } = useAuth();
	if (!isAuthenticated) return children;
	return <StaticOptionsProvider>{children}</StaticOptionsProvider>;
}

function AppContent() {
	return (
		<ConditionalStaticOptions>
			<NavigationBlocker>
				<Routes>
					<Route path="/" element={<PublicRoute><Login/></PublicRoute>} />
					<Route path="/Home" element={<ProtectedRoute><Home/></ProtectedRoute>} />
					<Route path="/Admin" element={<ProtectedRoute><AdminProtectedRoute><Admin/></AdminProtectedRoute></ProtectedRoute>} />
					<Route path="/Admin/ModellKezelo" element={<ProtectedRoute><AdminProtectedRoute><AdminModellKezelo/></AdminProtectedRoute></ProtectedRoute>} />
					<Route path="/Admin/Modell/:modelId" element={<ProtectedRoute><AdminProtectedRoute><AdminModell/></AdminProtectedRoute></ProtectedRoute>} />
					<Route path="/Rendelesek" element={<ProtectedRoute><Rendelesek/></ProtectedRoute>} />
					<Route path="/MeretfelveteliHely" element={<ProtectedRoute><MeretfelveteliHely /></ProtectedRoute>} />
					<Route path='/Meretlap' element={<ProtectedRoute><Meretlap /></ProtectedRoute>} />
					<Route path='/RendelesTipus' element={<ProtectedRoute><RendelesTipus /></ProtectedRoute>} />
					<Route path='/VoltMegrendeles' element={<ProtectedRoute><VoltMegrendeles /></ProtectedRoute>} />
					<Route path='/Taj' element={<ProtectedRoute><Taj /></ProtectedRoute>} />
					<Route path='/Adat' element={<ProtectedRoute><Adat /></ProtectedRoute>} />
					<Route path='/VenyesTipus' element={<ProtectedRoute><VenyesTipus /></ProtectedRoute>} />
					<Route path='/AdatVenyes' element={<ProtectedRoute><AdatVenyes /></ProtectedRoute>} />
					<Route path='/KozgyogyKerdes' element={<ProtectedRoute><KozgyogyKerdes /></ProtectedRoute>} />
					<Route path='/UzemiKerdes' element={<ProtectedRoute><UzemiKerdes /></ProtectedRoute>} />
					<Route path='/EgyediKerdes' element={<ProtectedRoute><EgyediKerdes /></ProtectedRoute>} />
					<Route path='/BetetTipus' element={<ProtectedRoute><BetetTipus /></ProtectedRoute>} />
					<Route path='/Mennyiseg' element={<ProtectedRoute><Mennyiseg /></ProtectedRoute>} />
					<Route path='/CipoTipus' element={<ProtectedRoute><CipoTipus /></ProtectedRoute>} />
					<Route path='/CipoForma' element={<ProtectedRoute><CipoForma /></ProtectedRoute>} />
					<Route path='/ModellValaszto' element={<ProtectedRoute><ModellValaszto /></ProtectedRoute>} />
					<Route path='/ValasztottModell' element={<ProtectedRoute><ValasztottModell /></ProtectedRoute>} />
					<Route path='/RogzitesTipus' element={<ProtectedRoute><RogzitesTipus/></ProtectedRoute>} />
					<Route path='/SpecialisIgeny' element={<ProtectedRoute><SpecialisIgeny /></ProtectedRoute>} />
					<Route path='/EgySzinu' element={<ProtectedRoute><EgySzinu /></ProtectedRoute>} />
					<Route path='/VenyesTartozek' element={<ProtectedRoute><VenyesTartozek /></ProtectedRoute>} />
					<Route path='/TartozekValaszto' element={<ProtectedRoute><TartozekValaszto /></ProtectedRoute>} />
					<Route path='/BetetTartozek' element={<ProtectedRoute><BetetTartozek /></ProtectedRoute>} />
					<Route path='/OsszesitoTablazat' element={<ProtectedRoute><OsszesitoTablazat /></ProtectedRoute>} />
					<Route path='/TeritesiDij' element={<ProtectedRoute><TeritesiDij /></ProtectedRoute>} />
					<Route path='/TobbSzinu' element={<ProtectedRoute><TobbSzinu/></ProtectedRoute>} />
					<Route path='/Kerdesek' element={<ProtectedRoute><Kerdesek/></ProtectedRoute>} />
					<Route path='/OrrForma' element={<ProtectedRoute><OrrForma/></ProtectedRoute>} />
					<Route path='/TalpSarok' element={<ProtectedRoute><TalpSarok/></ProtectedRoute>} />
					<Route path='/TalpRamaSzine' element={<ProtectedRoute><TalpRamaSzine/></ProtectedRoute>} />
					<Route path='/PartnerValaszto' element={<ProtectedRoute><PartnerValaszto/></ProtectedRoute>} />
					<Route path='/BelesTipus' element={<ProtectedRoute><BelesTipus/></ProtectedRoute>} />
					<Route path='/KeregTipus' element={<ProtectedRoute><KeregTipus/></ProtectedRoute>} />
					<Route path='/OrrMerevito' element={<ProtectedRoute><OrrMerevito/></ProtectedRoute>} />
					<Route path='/Donga' element={<ProtectedRoute><Donga/></ProtectedRoute>} />
					<Route path='/Gordulo' element={<ProtectedRoute><Gordulo/></ProtectedRoute>} />
					<Route path='/CsatolandoMedia' element={<ProtectedRoute><CsatolandoMedia/></ProtectedRoute>} />
					<Route path='/Meretvetel' element={<ProtectedRoute><Meretvetel/></ProtectedRoute>} />
					<Route path='/MeretvetelSzaras' element={<ProtectedRoute><MeretvetelSzaras/></ProtectedRoute>} />
					<Route path='/Emeles' element={<ProtectedRoute><Emeles/></ProtectedRoute>} />
					<Route path='/FelolvasoTabla' element={<ProtectedRoute><FelolvasoTabla/></ProtectedRoute>} />
					<Route path='/VenyekLista' element={<ProtectedRoute><VenyekLista /></ProtectedRoute>} />
					<Route path='/Alairas' element={<ProtectedRoute><Alairas /></ProtectedRoute>} />
					<Route path='/MeretlapNyomtatas' element={<ProtectedRoute><MeretlapNyomtatas/></ProtectedRoute>} />
					<Route path='/ProjektValaszto' element={<ProtectedRoute><ProjektValaszto/></ProtectedRoute>} />
					<Route path='/RendelesAdatlap' element={<ProtectedRoute><RendelesAdatlap/></ProtectedRoute>} />
					<Route path='/TuzesSzine' element={<ProtectedRoute><TuzesSzine/></ProtectedRoute>} />
					<Route path='/Diviziok' element={<ProtectedRoute><Diviziok/></ProtectedRoute>} />
					<Route path='/ElolegSzamla' element={<ProtectedRoute><ElolegSzamla/></ProtectedRoute>} />
					<Route path='/Szamlazas' element={<ProtectedRoute><Szamlazas/></ProtectedRoute>} />
					<Route path='/Talp' element={<ProtectedRoute><Talp/></ProtectedRoute>} />
					<Route path='/Koztalp' element={<ProtectedRoute><Koztalp/></ProtectedRoute>} />
					<Route path='/Rama' element={<ProtectedRoute><Rama/></ProtectedRoute>} />
					{/* <Route path='/KapocsFuzo' element={<ProtectedRoute><KapocsFuzo/></ProtectedRoute>} /> */}
				</Routes>
			</NavigationBlocker>
		</ConditionalStaticOptions>
	);
}

function App() {
	return (
		<Router>
			<OrderProvider>
				<OrderSaveProvider>
					<PrescriptionSaveProvider>
						<InvoiceSaveProvider>
							<AuthProvider>
								<AppContent />
							</AuthProvider>
						</InvoiceSaveProvider>
					</PrescriptionSaveProvider>
				</OrderSaveProvider>
			</OrderProvider>
		</Router>
	);
}

const NavigationBlocker = ({ children }) => {
    const location = useLocation();
    const navigate = useStepNavigate();
    const { orderLoading, order } = useOrder();

    const navigateToSavedStep = () => {
        const savedStep = localStorage.getItem("step_page");
        const savedOrderSzam = localStorage.getItem("hmeliorder_szam");
        const currentPath = location.pathname;

        console.log('Navigation check:', {
            orderLoading,
            savedStep,
            savedOrderSzam,
            currentPath,
            currentOrderSzam: order?.hmeliorder?.hmeliorder_szam
        });

        if (!orderLoading && 
            savedStep && 
            savedOrderSzam && 
            order?.hmeliorder?.hmeliorder_szam === Number(savedOrderSzam) && 
            currentPath !== savedStep
        ) {
            console.log('Navigating to:', savedStep);
            navigate(savedStep, { replace: true });
        }
    };

    useEffect(() => {
        if (!orderLoading) {
            navigateToSavedStep();
        }
    }, [orderLoading, order?.hmeliorder?.hmeliorder_szam]);

    useEffect(() => {
        window.history.pushState(null, "", window.location.href);
        
        const handlePopState = () => {
            navigateToSavedStep();
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [order?.hmeliorder?.hmeliorder_szam]);

	return children;
};

export default App;
